import React from 'react'

const Logo: React.FC = () => {
  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    const isHome = window.location.pathname === '/'
    if (isHome) {
      e.preventDefault()
      const el = document.getElementById('hero')
      el?.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className="flex items-center ml-4 md:ml-6 lg:ml-8">
      <a
        href="/#hero"
        onClick={handleClick}
        className="flex items-center space-x-3 space-x-reverse group transition-all duration-200 hover:opacity-90"
        aria-label="الذهاب إلى قسم الهيرو"
      >
        <div className="relative w-10 h-10 sm:w-11 sm:h-11 flex-shrink-0">

          {/* 1. شعار الوضع الفاتح: يظهر افتراضياً ويختفي تماماً في الدارك مود */}
          <img 
            src="/logo.png" 
            alt="BadanIbex® Logo - Light Mode" 
            className="absolute inset-0 w-full h-full object-contain rounded-md shadow-sm group-hover:border-gold block dark:hidden opacity-100 transition-all duration-300 ease-in-out" 
          />

          {/* 2. شعار الوضع الداكن: يختفي افتراضياً ويظهر فقط عند تفعيل كلاس .dark */}
          <img 
            src="/logo.png" 
            alt="BadanIbex® Logo - Dark Mode" 
            className="absolute inset-0 w-full h-full object-contain rounded-md shadow-sm group-hover:border-gold hidden dark:block opacity-100 transition-all duration-300 ease-in-out" 
          />

        </div>

        {/* النص بالبروفايل الحديث المعتمد */}
        <span className="text-xl sm:text-2xl font-bold tracking-tight text-text-main group-hover:text-gold transition-colors duration-200 flex items-center gap-0.5">
          BadanIbex
          <span className="text-xs text-gold font-normal align-super select-none"></span>
        </span>
      </a>
    </div>
  )
}

export default Logo
